export default __webpack_public_path__ + "static/media/pic6.0b1ccca7.jpg";